import { combineReducers } from "redux";
import localstorage from './localstorage'

export default combineReducers({
    localstorage
});
